var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"max-width":"1200"}},[_c('Breadcrumbs',{attrs:{"items":_vm.breadcrumbsItems}}),_c('top-info-action',{attrs:{"principal-btn-title":"Nuevo role","subtitle":"Crea, busca, filtra y visualiza roles","title":"Roles"},on:{"setDefaultPrimaryAction":_vm.createNewProduct}}),_c('RoleResume')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }